module.exports = __webpack_public_path__ + "fonts/NespressoLucas-MedItalic.ttf?v=84465ceaf50bd3957ea2a22717b89731";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-MedItalic.ttf
// module id = 666
// module chunks = 0